<template>
  <div class="home">
    <div class="preloader" v-if="page.loading">
      <div class="spinner-loading"></div>
    </div>
    <banner :banner="page.data.main_banner"></banner>
    <slider
      :component="'product'"
      :items="page.data.arrivals"
      :title="$t('title.arrivals')"
      :badge="'new'"
      :slide_count="4"
    ></slider>
    <about :data="page.data.second_section"></about>
    <category :categories="page.data.categories" :banner="page.data.categories_banner"></category>
    <slider
      :component="'product'"
      :items="page.data.best_seller"
      :title="$t('title.seller')"
      :badge="'best-blue'"
      :slide_count="4"
    ></slider>
    <promo :banner="page.data.promo_banner"></promo>
    <!--<slider-->
      <!--:component="'instagram'"-->
      <!--:items="instagram"-->
      <!--:title="$t('title.instagram_title')"-->
      <!--:badge="false"-->
      <!--:slide_count="4"-->
    <!--&gt;</slider>-->
    <subscribe class="section"></subscribe>
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/home/Banner.vue';
import Slider from '@/components/home/Slider.vue';
import About from '@/components/home/About.vue';
import Category from '@/components/home/Category.vue';
import Promo from '@/components/home/Promo.vue';
import Subscribe from '@/components/home/Subscribe.vue';
import { mapState } from 'vuex';

export default {
  name: 'home',
  components: {
    Banner,
    Slider,
    About,
    Category,
    Promo,
    Subscribe
  },
  i18n: {
    messages: {
      en: {
        title: {
          arrivals: 'NEW',
          sale: 'SALE',
          seller: 'BEST SELLER',
          editorial: 'L’editorial',
          instagram_title: "WE'RE ON INSTAGRAM"
        }
      },
      hy: {
        title: {
          arrivals: 'ՆՈՐ ՏԵՍԱԿԱՆԻ',
          sale: 'ԶԵՂՉ',
          seller: 'ԼԱՎԱԳՈՒՅՆ ՎԱՃԱՌՎՈՂ',
          editorial: 'ԲԼՈԳ',
          instagram_title: 'ՀԵՏԵՎԵՔ ՄԵԶ ԻՆՍՏԱԳՐԱՄՈՒՄ'
        }
      },
      ru: {
        title: {
          arrivals: 'НОВЫЕ',
          sale: 'СПЕЦИАЛЬНЫЕ ПРЕДЛОЖЕНИЯ',
          seller: 'БЕСТСЕЛЛЕРЫ',
          instagram_title: 'МЫ В ИНСТАГРАМ'
        }
      }
    }
  },
  created () {
    // var t = this
    // axios
    //   .get(
    //     'https://api.instagram.com/v1/users/self/media/recent/?access_token=4251226468.1677ed0.97adf65390644e789c18fe22376223f4&count=10'
    //   )
    //   .then(({ data }) => {
    //     console.log(data.data)
    //
    //     for (var key in data.data) {
    //       this.instagram.unshift({
    //         image: data.data[key].images.low_resolution.url,
    //         link: data.data[key].link
    //       })
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error)
    //     this.error = true
    //   })
  },
  data () {
    return {
      banner: {
        image: '/img/banner.jpg',
        title: 'home.banner.title',
        description: 'home.banner.description',
        cta_text: 'home.banner.cta_text',
        cta_action: '/shop'
      },
      instagram: []
    };
  },
  computed: mapState(['page'])
};
</script>

<style lang="scss">
.home {
  .banner {
    .banner-caption {
      max-width: 450px;
    }
  }
  .preloader{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;

    .spinner-loading {
      width: 70px;
      height: 70px;
      background-color: #ffbe00;

      margin: 100px auto;
      -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
      animation: sk-rotateplane 1.2s infinite ease-in-out;
    }

    @-webkit-keyframes sk-rotateplane {
      0% { -webkit-transform: perspective(120px) }
      50% { -webkit-transform: perspective(120px) rotateY(180deg) }
      100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }
    }

    @keyframes sk-rotateplane {
      0% {
        transform: perspective(120px) rotateX(0deg) rotateY(0deg);
        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
      } 50% {
          transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
          -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
        } 100% {
            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
          }
    }

  }
}
</style>
